module.exports = __webpack_public_path__ + "img/icon_map_53_on_100.72b36a28.png";